import { forwardRef } from 'react';
import { getStatusColor, removeHttpVariations } from '../../../utils/utilFunctions';

import IconButton from '@mui/material/IconButton';
import LaunchIcon from '@mui/icons-material/Launch';
import Chip from '@mui/material/Chip';

const CustomInputLink = forwardRef((props, _ref) => {
	const { text, link, chip, hideLinkIcon, onIconClick } = props;
	const url = link ? `https://${removeHttpVariations(link)}` : '';

	return (
		<div style={{ display: 'flex', gap: '10px', alignItems: 'center', padding: '16.5px 14px' }}>
			{chip && (
				<Chip
					id={'programDetails-statusChip'}
					data-testid={`programDetails-statusChip`}
					label={chip}
					sx={{
						backgroundColor: getStatusColor(chip),
						color: chip === 'Unassigned' ? 'black' : 'white!important',
						WebkitTextFillColor: chip === 'Unassigned' ? 'black' : 'white!important'
					}}
					size="small"
				/>
			)}
			<a
				onClick={() => {
					link?.[0] === '/' ? (window.location.href = link) : window.open(url);
				}}
			>
				{text}
			</a>

			{text && (
				<IconButton
					aria-label="open link"
					onMouseDown={(e) => e.preventDefault()} // prevents blur before click
					onClick={(e) => {
						e.preventDefault();
						e.stopPropagation();
						onIconClick?.();
					}}
					edge="end"
					style={{ padding: '0px' }}
				>
					{!hideLinkIcon && <LaunchIcon />}
				</IconButton>
			)}
		</div>
	);
});

export default CustomInputLink;
